/* Inc / ex VAT price display.

   Shopify stores and charges one price — the VAT-inclusive one — so this is a display
   layer only: every price on the page is divided by 1 + rate when "Ex VAT" is chosen,
   and restored from the original text when the shopper switches back. Nothing about the
   cart, the order or the amount taken at checkout changes, which is why the checkout
   still shows VAT-inclusive totals and the bar says so.

   The original inclusive text is kept in data-d2f-inc on each element, so switching back
   is an exact restore rather than a second piece of arithmetic (no rounding drift).

   Prices arrive after load too — cart drawer, quick add, facet re-renders — so a
   MutationObserver re-applies the choice to anything new.
*/
(function () {
  var KEY = 'd2f-vat-mode';
  var RATE = parseFloat(document.documentElement.dataset.d2fVatRate || '0.2');
  // Dawn renders money inside these; the cart and totals reuse the same classes.
  var SELECTOR = [
    '.price-item',
    '.price__regular .price-item',
    '.cart-item__price-wrapper .price',
    '.totals__total-value',
    '.cart-item__totals .price',
    '.unit-price',
    '.d2f-price',
  ].join(',');

  function mode() {
    try {
      return localStorage.getItem(KEY) === 'ex' ? 'ex' : 'inc';
    } catch (e) {
      return 'inc';
    }
  }

  function convert(text) {
    // Only touch the numbers, so "From £119.25" and "£40.45 - £60.00" survive intact.
    return text.replace(/(\d[\d,]*(?:\.\d{2})?)/g, function (match) {
      var value = parseFloat(match.replace(/,/g, ''));
      if (isNaN(value)) return match;
      var ex = value / (1 + RATE);
      return ex.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }

  function apply(root) {
    var ex = mode() === 'ex';
    (root || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.querySelector(SELECTOR)) return; // only leaf price nodes
      if (!el.dataset.d2fInc) el.dataset.d2fInc = el.textContent;
      var inc = el.dataset.d2fInc;
      var wanted = ex ? convert(inc) : inc;
      if (el.textContent !== wanted) el.textContent = wanted;
    });

    document.querySelectorAll('[data-d2f-vat-note]').forEach(function (note) {
      note.textContent = ex ? 'Prices exclude VAT. VAT is added at checkout.' : 'Prices include VAT.';
    });
    document.querySelectorAll('.product__tax').forEach(function (el) {
      if (!el.dataset.d2fInc) el.dataset.d2fInc = el.textContent;
      el.textContent = ex ? 'Excluding VAT. VAT is added at checkout.' : el.dataset.d2fInc;
    });

    document.querySelectorAll('[data-d2f-vat] button').forEach(function (btn) {
      var on = btn.dataset.mode === (ex ? 'ex' : 'inc');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-on', on);
    });
    document.documentElement.setAttribute('data-vat-mode', ex ? 'ex' : 'inc');
  }

  function choose(next) {
    try {
      localStorage.setItem(KEY, next);
    } catch (e) {
      /* private mode: the choice just will not persist */
    }
    apply();
  }

  // Capture phase on purpose. Dawn's MenuDrawer binds a "close submenu" handler to every
  // <button> inside the drawer, so a tap on the VAT switch stripped the drawer's
  // menu-opening class while leaving it open and the body scroll-locked. Catching the
  // click before it reaches the button stops Dawn's handler from ever running.
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest && event.target.closest('[data-d2f-vat] button');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      choose(btn.dataset.mode);
    },
    true
  );

  window.d2fApplyVat = apply;   // sections that rebuild prices can re-run the conversion

  function start() {
    apply();
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var node = records[i].addedNodes[j];
          if (node.nodeType === 1) {
            apply(node.matches && node.matches(SELECTOR) ? node.parentNode : node);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
